"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "James Anderson",
  quote: "Bottom Up Projects delivered our commercial fit-out with surgical precision. Their project management systems kept us informed at every milestone, ensuring total accountability.",
  position: "Operations Manager",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/avatar_james.png",
  initials: "JA"
}, {
  author: "Sarah Chen",
  quote: "The remedial works on our industrial facility were handled with absolute compliance and technical expertise. They are a truly reliable partner for high-stakes construction projects.",
  position: "Facilities Director",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/avatar_sarah.png",
  initials: "SC"
}, {
  author: "Michael Ross",
  quote: "From defect management to final refurbishment, their team's focus on quality and safety is unmatched. They delivered a high-end finish safely and strictly to programme.",
  position: "Senior Project Manager",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/avatar_michael.png",
  initials: "MR"
}];
export default function OgrenciVeOgretmenGorusleri() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="228730" id="project-validation" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden" ref={ref}>
      {}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center">
        <div className="w-full max-w-[800px] aspect-square bg-[radial-gradient(circle_at_center,hsla(210,100%,50%,0.05)_0%,transparent_60%)] rounded-full blur-3xl opacity-70" />
      </div>

      <div className={`container mx-auto px-4 relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="max-w-4xl mx-auto">
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="p-2 md:p-6">
                    <Card className="bg-transparent border-none shadow-none">
                      <CardContent className="flex flex-col items-center text-center p-6 md:p-10">
                        <div className="relative mb-8">
                          <SafeHydrate><Avatar className="size-20 md:size-24 border-4 border-background shadow-xl rounded-sm overflow-hidden">
                            <AvatarImage src={testimonial.avatar} alt={testimonial.author} />
                            <AvatarFallback className="text-xl bg-muted text-muted-foreground font-mono">
                              {testimonial.initials}
                            </AvatarFallback>
                          </Avatar></SafeHydrate>
                          <div className="absolute -bottom-3 -right-3 bg-primary text-primary-foreground p-2 rounded-sm shadow-lg">
                            <Quote className="size-4 md:size-5" />
                          </div>
                        </div>

                        <Badge variant={testimonial.position === "Senior Project Manager" ? "secondary" : "default"} className="mb-6 text-xs px-4 py-1 font-mono uppercase tracking-wider rounded-sm">
                          {testimonial.position}
                        </Badge>

                        <blockquote className="text-2xl md:text-3xl leading-relaxed italic font-default text-foreground mb-8 max-w-3xl">
                          "{testimonial.quote}"
                        </blockquote>

                        <div className="mt-auto">
                          <cite className="not-italic font-semibold text-lg text-foreground font-default uppercase tracking-wide">
                            {testimonial.author}
                          </cite>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="flex items-center justify-center gap-4 mt-8">
              <CarouselPrevious className="relative inset-auto translate-x-0 translate-y-0 bg-primary text-primary-foreground hover:bg-secondary hover:text-secondary-foreground border-none shadow-md rounded-sm transition-colors" />
              <CarouselNext className="relative inset-auto translate-x-0 translate-y-0 bg-primary text-primary-foreground hover:bg-secondary hover:text-secondary-foreground border-none shadow-md rounded-sm transition-colors" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}